<template>
    <div>
        <h1>You can't view this profile because the user has blocked you</h1>
    </div>
</template>

<script>
export default {
    name: 'Blocked'
}
</script>
